import axios from 'axios'
import { getHeaderUploadFile } from '../../helpers/utility'

const postRequest = async (url, payload) =>
  await axios.post(url, payload, { headers: getHeaderUploadFile() })

export default postRequest
